import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const RegistriesListAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
